import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { config } from '@uhg-abyss/web/tools/config';
import { PageLayout } from '@src/common/PageLayout';

const FooterBar = styled('div', {
  backgroundColor: '$white',
  height: '56px',
  position: 'relative',
  bottom: '0',
  width: '100%',
});
const FooterText = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '18px 20px',
  fontSize: 14,
  color: '$gray9',
});

const FooterLink = styled('p', {
  textAlign: 'end',
  color: '$accent1',
  fontWeight: 500,
  height: '18px',
  letterSpacing: '0px',
  lineHeight: '18px',
  marginLeft: '20px',
});
export const Footer = () => {
  return (
    <FooterBar>
      <PageLayout>
        <FooterText>
          <Flex style={{ width: '100%', justifyContent: 'space-between' }}>
            <span>UnitedHealthcare Services | All Rights Reserved</span>
            <div style={{ display: 'flex' }}>
              <FooterLink>
                <a
                  id="privacy-policy"
                  href={config('UHC_PRIVACY_URL')}
                  rel="noreferrer"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </FooterLink>
              <FooterLink>
                <a
                  id="terms-of-use"
                  href={config('UHC_TERMS_OF_USE_URL')}
                  rel="noreferrer"
                  target="_blank"
                >
                  Terms of Use
                </a>
              </FooterLink>
              <FooterLink>
                <a
                  id="accessibility"
                  href={config('UHC_ACCESSIBILITY_URL')}
                  rel="noreferrer"
                  target="_blank"
                >
                  Accessibility
                </a>
              </FooterLink>
              <FooterLink>
                <a
                  id="contact-us"
                  href={config('UHC_CONTACT_US_URL')}
                  rel="noreferrer"
                  target="_blank"
                >
                  Contact Us
                </a>
              </FooterLink>
            </div>
          </Flex>
        </FooterText>
      </PageLayout>
    </FooterBar>
  );
};
